import styled from 'styled-components';
import { body2 } from 'ui/theme';

import { pxToRem } from 'utils/convert';

import { Cell } from '../../components/table';
import { LIST_TYPE_NAMES, TABLE_COLUMNS } from '../constants';
import { List } from '../../domain/list';

interface ListTypeCellProps {
  list: List;
}

const CellWrapper = styled(Cell)`
  height: ${pxToRem(90)};
  width: 100%;
`;

export const LabelWrapper = styled.div`
  ${body2};
`;

export const ListTypeCell = ({ list }: ListTypeCellProps) => {
  const { emailListType } = list;
  const label = LIST_TYPE_NAMES[emailListType];

  return (
    <CellWrapper columnId={TABLE_COLUMNS.TYPE} data-test="list-type-cell">
      <LabelWrapper>{label}</LabelWrapper>
    </CellWrapper>
  );
};
